import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateSearchQuery } from "../../store/slices/tableSlice";
import { SearchBar, Pagination } from "../../components";
import {
  fetchDebtAllUser,
  getAllPaymet,
  getDebtForEachDriveSchool,
  payDebtDriveSchool,
  resetPay,
  setPage,
  toggleHideOrShowEarnings,
} from "../../store/slices/debtSlice";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { BiReset } from "react-icons/bi";
import InfoModal from "../Modals/InfoModal";
import barazimetAdd from "../../assets/barazimetAdd.png";
import barazimetInfo from "../../assets/barazimetInfo.png";
import { useRef } from "react";

const TableFinancialBalance = () => {
  const dispatch = useDispatch();
  const totalCount = useSelector((state) => state.debt.totalCount);
  const currentPage = useSelector((state) => state.debt.currentPage);
  const debt = useSelector((state) => state.debt.data);
  const payDebtStatus = useSelector((state) => state.debt.payDebtStatus);
  const loadingReset = useSelector((state) => state.debt.loadingResetPay);
  const driveSchoolDebtDetails = useSelector(
    (state) => state.debt.debtForEachSchool
  );

  const [searchInput, setSearchInput] = useState("");
  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  const [open, setOpen] = useState(false);
  const [openResetModal, setOpenResetModal] = useState(false);
  const [id, setId] = useState(0);

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [pendingPayment, setPendingPayment] = useState({
    amount: "",
    description: "",
  });
  const [openDebtDetailsModal, setOpenDebtDetailsModal] = useState(false);

  const [loadingDebtDetails, setLoadingDebtDetails] = useState(false);
  const [debtDetailsError, setDebtDetailsError] = useState(null);

  const [localHideMap, setLocalHideMap] = useState({});
  const prevSearchRef = useRef("");

  const openInfoModalFunction = async (driveSchoolId) => {
    setOpenDebtDetailsModal(true);
    setLoadingDebtDetails(true);
    setDebtDetailsError(null);

    try {
      const resultAction = await dispatch(
        getDebtForEachDriveSchool(driveSchoolId)
      );
    } catch (error) {
      setDebtDetailsError(error.message || "Something went wrong");
    } finally {
      setLoadingDebtDetails(false);
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    dispatch(updateSearchQuery(searchInput));
  };

  const handlePageChange = (page) => {
    console.log("page", page);
    dispatch(setPage(page));
  };

  useEffect(() => {
    const fetchData = async () => {
      const pageToUse = prevSearchRef.current !== searchInput ? 1 : currentPage;

      if (prevSearchRef.current !== searchInput) {
        dispatch(setPage(1));
        prevSearchRef.current = searchInput;
      }

      const action = await dispatch(
        fetchDebtAllUser({ page: pageToUse, searchQuery: searchInput })
      );
      const responseData = action.payload?.data;

      if (responseData) {
        const newMap = {};
        responseData.forEach((item) => {
          newMap[item.user_id] = item.hide_earnings === 1;
        });
        setLocalHideMap(newMap);
      }
    };

    fetchData();
    dispatch(getAllPaymet());
  }, [dispatch, currentPage, searchInput, payDebtStatus, loadingReset]);

  const handleToggleEarnings = async (userId) => {
    setLocalHideMap((prev) => ({
      ...prev,
      [userId]: !prev[userId],
    }));

    const action = await dispatch(toggleHideOrShowEarnings(userId));

    if (toggleHideOrShowEarnings.fulfilled.match(action)) {
      setLocalHideMap((prev) => ({
        ...prev,
        [userId]: action.payload.hide_earnings === 1,
      }));
    } else {
      toast.error("Nuk u bë ndryshimi. Ju lutem provoni përsëri.");

      setLocalHideMap((prev) => ({
        ...prev,
        [userId]: !prev[userId],
      }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setPendingPayment({ amount, description });
    setOpen(false);
    setConfirmModalOpen(true);
  };

  const handleConfirmedPayment = () => {
    const data = {
      userId,
      amount: pendingPayment.amount,
      description: pendingPayment.description,
    };
    try {
      dispatch(payDebtDriveSchool(data));
      setAmount("");
      setDescription("");
      setOpen(false);
      setConfirmModalOpen(false);
      toast.success("Pagesa shkoi me sukses");
    } catch (error) {
      console.log(error);
    }
  };

  const resetPayment = (id) => {
    try {
      dispatch(resetPay(id));
      toast.success("Te dhenat jane freskuar me sukses");
    } catch (error) {
      console.log(error);
    }
  };

  const openResetModalFunction = (id) => {
    setId(id);
    setOpenResetModal(!openResetModal);
  };

  const paymentArray = (data) => {
    const parsData = JSON.parse(data);
    const totalCalculationOfDriveSchool = parsData?.reduce(
      (totals, payment) => {
        if (payment.isActive === 1) {
          return totals + payment.amount;
        }
        return totals;
      },
      0
    );
    return totalCalculationOfDriveSchool;
  };

  const debtArray = (data) => {
    const parsData = JSON.parse(data);
    const totalPayDebt = parsData?.reduce((total, debt) => {
      return total + debt.amount;
    }, 0);
    return totalPayDebt;
  };

  const calcaulateTotalPriceAdmin = (data) => {
    const parsData = JSON.parse(data);
    const totalProfitAdmin = parsData?.filter((item) => item.isActive === 1);
    return totalProfitAdmin.reduce((total, profit) => {
      return total + profit.adminPrice;
    }, 0);
  };

  const calculateAdminPrice = (data) => {
    const parsData = JSON.parse(data);
    const totalProfitAdmin = parsData?.filter((item) => item.isActive === 1);
    return totalProfitAdmin.reduce((total, profit) => {
      if (profit.cash === 1) {
        return total + profit.adminPrice;
      } else {
        return total - profit.schoolPrice;
      }
    }, 0);
  };

  const calculateBalance = (paymentData, debtData) => {
    const totalPayment = calculateAdminPrice(paymentData);
    const totalDebt = debtArray(debtData);
    const balance = totalPayment - totalDebt;
    return balance || 0;
  };

  const debtBank = (data) => {
    const parsData = JSON.parse(data);
    const debt = parsData.filter((item) => item.cash === 0);
    return debt.reduce((total, debt) => {
      return total + debt.amount;
    }, 0);
  };

  function makePositive(number) {
    if (number < 0) {
      return -number;
    } else {
      return number;
    }
  }

  return (
    <div className="p-3">
      <div className="pb-4">
        <SearchBar
          searchInput={searchInput}
          handleSearchInputChange={handleSearchInputChange}
          handleSearchSubmit={handleSearchSubmit}
        />
      </div>

      <div
        className="relative overflow-x-auto shadow-md sm:rounded-lg"
        style={{ borderRadius: 1 }}
      >
        <div className="hidden sm:block">
          <table className="w-full table-auto text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs bg-gray-50 text-[#718EBF]">
              <tr>
                <th scope="col" className="px-3 py-3 ">
                  Autoshkolla
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Qyteti
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Qarkullimi
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Permes Bankes
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Me cash
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Me kartel fizike
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Fitimi i autoshkollaime
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Mosbarazimi
                </th>
                <th scope="col" className="px-3 py-3 ">
                  Aksionet
                </th>
              </tr>
            </thead>
            <tbody>
              {debt?.data?.map((item) => {
                return (
                  <tr
                    key={item.id}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                  >
                    <td className="px-4 py-4  truncate max-w-xs">
                      {item.name}
                    </td>
                    <td className="px-4 py-4  truncate max-w-xs">
                      {item.city}
                    </td>
                    <td className="px-4 py-4  truncate max-w-xs">
                      {paymentArray(item.payments)} €
                    </td>
                    <td className="px-4 py-4  truncate max-w-xs">
                      {debtBank(item.payments)}
                    </td>
                    <td className="px-4 py-4  truncate max-w-xs">
                      {debtArray(item.debts) && `${debtArray(item.debts)}`}€
                    </td>
                    <td className="px-4 py-4  truncate max-w-xs">N/A €</td>
                    <td className="px-4 py-4  truncate max-w-xs">
                      {calcaulateTotalPriceAdmin(item.payments)} €
                    </td>
                    <td className="px-4 py-4  truncate max-w-xs">
                      {calculateBalance(item.payments, item.debts) > 0
                        ? "-"
                        : "+"}{" "}
                      {makePositive(
                        calculateBalance(item.payments, item.debts)
                      )}{" "}
                      €
                    </td>
                    <td onClick={() => {}} className="px-4 py-4">
                      <div className="flex gap-1">
                        <button
                          onClick={() => {
                            setOpen(!open);
                            setUserId(item.user_id);
                          }}
                        >
                          <MdOutlineAddCircleOutline
                            style={{
                              width: 23,
                              height: 23,
                              marginBottom: 3,
                              color: "#21C621",
                            }}
                          />
                        </button>
                        <button
                          onClick={() => openInfoModalFunction(item.user_id)}
                          className="text-blue-500 text-sm"
                        >
                          <InfoModal
                            title="Info rreth testit"
                            name="Emri i testit"
                            categoryInInfo="Kategoria e testit"
                          />
                        </button>
                        <button
                          onClick={() => openResetModalFunction(item.user_id)}
                        >
                          <BiReset
                            style={{
                              width: 23,
                              height: 23,
                              marginBottom: 3,
                              color: "#FF0004",
                            }}
                          />
                        </button>
                        <button
                          onClick={() => handleToggleEarnings(item.user_id)}
                        >
                          {localHideMap[item.user_id] ? (
                            <FiEyeOff
                              className="text-red-500 text-lg"
                              style={{ width: 23, height: 23, marginBottom: 3 }}
                            />
                          ) : (
                            <FiEye
                              className="text-green-500 text-lg"
                              style={{ width: 23, height: 23, marginBottom: 3 }}
                            />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="md:hidden flex flex-col gap-4">
          {debt?.data?.map((item) => (
            <div key={item.id} className="bg-white shadow rounded-lg p-4">
              <div className="mb-2">
                <span className="font-semibold text-gray-700">
                  Autoshkolla:
                </span>{" "}
                {item.name}
              </div>
              <div className="mb-2">
                <span className="font-semibold text-gray-700">Qyteti:</span>{" "}
                {item.city}
              </div>
              <div className="mb-2">
                <span className="font-semibold text-gray-700">Qarkullimi:</span>{" "}
                {paymentArray(item.payments)} €
              </div>
              <div className="mb-2">
                <span className="font-semibold text-gray-700">
                  Përmes Bankës:
                </span>{" "}
                {debtBank(item.payments)}
              </div>
              <div className="mb-2">
                <span className="font-semibold text-gray-700">Me Cash:</span>{" "}
                {debtArray(item.debts)} €
              </div>
              <div className="mb-2">
                <span className="font-semibold text-gray-700">
                  Kartel Fizike:
                </span>{" "}
                N/A €
              </div>
              <div className="mb-2">
                <span className="font-semibold text-gray-700">Fitimi:</span>{" "}
                {calcaulateTotalPriceAdmin(item.payments)} €
              </div>
              <div className="mb-2">
                <span className="font-semibold text-gray-700">
                  Mosbarazimi:
                </span>{" "}
                {calculateBalance(item.payments, item.debts) > 0 ? "-" : "+"}{" "}
                {makePositive(calculateBalance(item.payments, item.debts))} €
              </div>
              <div className="flex gap-2 mt-2">
                <button
                  onClick={() => {
                    setOpen(!open);
                    setUserId(item.user_id);
                  }}
                >
                  <MdOutlineAddCircleOutline
                    style={{
                      width: 23,
                      height: 23,
                      marginBottom: 3,
                      color: "#21C621",
                    }}
                  />
                </button>
                <button onClick={() => openInfoModalFunction(item.user_id)}>
                  <InfoModal
                    title="Info rreth testit"
                    name="Emri i testit"
                    categoryInInfo="Kategoria e testit"
                  />
                </button>
                <button onClick={() => openResetModalFunction(item.user_id)}>
                  <BiReset
                    style={{
                      width: 23,
                      height: 23,
                      marginBottom: 3,
                      color: "#FF0004",
                    }}
                  />
                </button>
                <button onClick={() => handleToggleEarnings(item.user_id)}>
                  {localHideMap[item.user_id] ? (
                    <FiEyeOff
                      className="text-red-500 text-lg"
                      style={{ width: 23, height: 23, marginBottom: 3 }}
                    />
                  ) : (
                    <FiEye
                      className="text-green-500 text-lg"
                      style={{ width: 23, height: 23, marginBottom: 3 }}
                    />
                  )}
                </button>
              </div>
            </div>
          ))}
        </div>
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
          filteredData={debt?.data}
        />
      </div>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-0">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>

          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-auto">
            <button
              type="button"
              className="absolute top-3 left-3 text-gray-400 bg-transparent rounded-full w-8 h-8 flex justify-center items-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <img src={barazimetAdd} alt="barazimet" className="w-6 h-6" />
            </button>

            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                Barazimi i Autoshkollës
              </h3>
              <form className="space-y-6 text-start" onSubmit={onSubmit}>
                <div>
                  <input
                    type="number"
                    name="amount"
                    id="amount"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="Shuma e pagesës"
                    required
                  />
                  <input
                    type="text"
                    name="descriptopm"
                    id="descriptopm"
                    className="bg-gray-50 mt-4 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Përshkrimi"
                  />
                  <div className="flex justify-center">
                    <div className="flex items-center mt-5 flex-wrap gap-2 justify-center">
                      <button
                        type="submit"
                        className="text-white bg-[#21C621] rounded-lg border text-sm font-medium px-5 py-2.5"
                      >
                        Paguaj
                      </button>

                      <button
                        data-modal-hide="popup-modal"
                        type="button"
                        onClick={() => {
                          setOpen(false);
                          setConfirmModalOpen(false);
                          setAmount("");
                          setDescription("");
                        }}
                        className="text-white bg-[#FF0000] rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5"
                      >
                        Anulo
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {confirmModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 sm:px-0">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>

          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-auto">
            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                A jeni i sigurt që do të paguani {pendingPayment.amount}€ ?
              </h3>
              <div className="flex flex-wrap justify-center gap-4">
                <button
                  onClick={handleConfirmedPayment}
                  className="text-white bg-[#21C621] rounded-lg text-sm font-medium px-5 py-2.5"
                >
                  Paguaj
                </button>
                <button
                  onClick={() => setConfirmModalOpen(false)}
                  className="text-white bg-[#FF0000] rounded-lg text-sm font-medium px-5 py-2.5"
                >
                  Anulo
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {openDebtDetailsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
          <div
            className="bg-gray-900 bg-opacity-40 absolute inset-0"
            onClick={() => setOpenDebtDetailsModal(false)}
          ></div>

          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-2xl p-4 sm:p-6 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <button>
                <img src={barazimetInfo} className="w-8 h-8" alt="info" />
              </button>

              <h3 className="text-lg sm:text-xl font-semibold text-center flex-grow">
                Lista e Barazimeve
              </h3>

              <button
                onClick={() => setOpenDebtDetailsModal(false)}
                className="text-gray-600 hover:text-gray-800 font-bold text-xl leading-none"
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            {loadingDebtDetails && <p className="text-center">Loading...</p>}

            {!loadingDebtDetails &&
              !debtDetailsError &&
              driveSchoolDebtDetails.length === 0 && (
                <p className="text-center text-gray-500">
                  Nuk ka barazime të regjistruara.
                </p>
              )}

            {!loadingDebtDetails && driveSchoolDebtDetails.length > 0 && (
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-center border border-gray-200 rounded-md">
                  <thead className="bg-gray-100 text-[#7B8BB2]">
                    <tr>
                      <th className="px-2 sm:px-4 py-2 border-b border-gray-300">
                        Data pageses
                      </th>
                      <th className="px-2 sm:px-4 py-2 border-b border-gray-300">
                        Shuma e pageses
                      </th>
                      <th className="px-2 sm:px-4 py-2 border-b border-gray-300">
                        Përshkrimi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {driveSchoolDebtDetails.map((debt) => (
                      <tr key={debt.id} className="text-black even:bg-gray-50">
                        <td className="py-2 px-2 sm:px-4 whitespace-nowrap">
                          {new Date(debt.create_at).toLocaleString("sq-AL", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })}
                        </td>
                        <td className="py-2 px-2 sm:px-4 whitespace-nowrap">
                          {debt.amount}€
                        </td>
                        <td className="py-2 px-2 sm:px-4 break-words max-w-xs">
                          {debt.description || "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {openResetModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
          <div
            className="bg-gray-900 bg-opacity-40 absolute inset-0"
            onClick={() => setOpenResetModal(false)}
          ></div>

          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md p-6">
            <button
              type="button"
              onClick={() => setOpenResetModal(false)}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
              aria-label="Close modal"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                A jeni i sigurt?
              </h3>
              <button
                className="bg-red-500 hover:bg-red-600 transition-colors rounded-full text-white px-6 py-2 text-sm font-semibold"
                onClick={() => resetPayment(id)}
              >
                Reseto
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableFinancialBalance;
